module.exports = __webpack_public_path__ + "static/img/2885_phase_function_Paper_PointsHejduk_Prediction.245c0b7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/2885_phase_function_Paper_PointsHejduk_Prediction.png
// module id = ZZ82
// module chunks = 0